module.exports = __webpack_public_path__ + "img/dsci0154.1aaf2b84.jpg";